import httpService from "..";

export const searchFuneralCustomersApi = async (groupId: string, search: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/customer/group/${groupId}/search?search=${search}`,
    "get"
  );
};

export const getFuneralCustomerApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/customer/${id}`,
    "get"
  );
};

export const getCompanyFuneralCustomersApi = async (groupId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/customer/group/${groupId}`,
    "get"
  );
};

export const addFuneralCustomerApi = async (data: {}, groupId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/customer?groupId=${groupId}`,
    "post",
    data
  );
};

export const editFuneralCustomerApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/customer/${id}`,
    "patch",
    data
  );
};
